import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default, { useContext } from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Button } from '../button/Button.js';
import { CollapseContext } from './CollapseContext.js';
import ToggleIcon from '../../../node_modules/@vinomofo/icons/esm/ToggleIcon-b44fe588.js';
import RoundDeleteIcon from '../../../node_modules/@vinomofo/icons/esm/RoundDeleteIcon-d44f346e.js';

var IconContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CollapseHeader__IconContainer",
  componentId: "sc-19jughr-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var CollapseButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "CollapseHeader__CollapseButton",
  componentId: "sc-19jughr-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    transition: transform ease-in-out 150ms, fill ease-in-out 150ms;\n  }\n"], ["\n  ", " {\n    transition: transform ease-in-out 150ms, fill ease-in-out 150ms;\n  }\n"])), IconContainer);
var CollapseHeader = function (_a) {
  var children = _a.children,
    _b = _a.icon,
    icon = _b === void 0 ? React__default.createElement(ToggleIcon, null) : _b,
    _c = _a.closeIcon,
    closeIcon = _c === void 0 ? React__default.createElement(RoundDeleteIcon, null) : _c,
    _d = _a.iconColor,
    iconColor = _d === void 0 ? ["dorianGray", "brand"] : _d,
    _e = _a.iconSize,
    iconSize = _e === void 0 ? "13px" : _e;
    _a.rotation;
    var rest = __rest(_a, ["children", "icon", "closeIcon", "iconColor", "iconSize", "rotation"]);
  var _g = useContext(CollapseContext),
    onClick = _g.onClick,
    isOpen = _g.isOpen;
  var _h = Array.isArray(iconColor) ? iconColor : [iconColor, iconColor],
    closedIconColor = _h[0],
    openIconColor = _h[1];
  return React__default.createElement(CollapseButton, __assign({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    onClick: onClick,
    padding: 10,
    isOpen: isOpen
  }, rest), children, React__default.createElement(IconContainer, {
    width: iconSize,
    height: iconSize,
    color: isOpen ? closedIconColor : openIconColor
  }, React__default.cloneElement(isOpen ? closeIcon ? closeIcon : icon : icon, {
    size: iconSize
  })));
};
var templateObject_1, templateObject_2;

export { CollapseHeader };
//# sourceMappingURL=CollapseHeader.js.map
